import { IRiskManagementLastConsultationsResponse } from 'services/riskManagement/types';

const mockRiskManagementLastConsultationsData: IRiskManagementLastConsultationsResponse = {
  data: [
    {
      partner: {
        id: '7x7vQ',
        name: 'skymark',
        alias: 'Skymark',
      },
      company: {
        id: '7x7',
        name: 'CORAL TRANSPORTES',
      },
      freight: {
        typeMerchandise: 'ARROZ',
      },
      grDate: '29/04/2024',
    },
    {
      partner: {
        id: '7x7T',
        name: 'guep',
        alias: 'Guep',
      },
      company: {
        id: 'sdfs',
        name: 'Coca-Cola',
      },
      freight: {
        typeMerchandise: 'Pallet',
      },
      grDate: '10/05/2024',
    },
    {
      partner: {
        id: '7x7vQ',
        name: 'skymark',
        alias: 'Skymark',
      },
      company: {
        id: 'asdq',
        name: 'Cimentos Brasil',
      },
      freight: {
        typeMerchandise: 'Cimento',
      },
      grDate: '29/04/2024',
    },
    {
      partner: {
        id: '7x7T',
        name: 'guep',
        alias: 'Guep',
      },
      company: {
        id: 'asda',
        name: 'Fazenda Três irmãos',
      },
      freight: {
        typeMerchandise: 'Boi',
      },
      grDate: '10/05/2024',
    },
  ],
};

export { mockRiskManagementLastConsultationsData };
